;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { readTopLevelFiltersFromUrl } from "@/lib/stores/url-storage";

export type TopLevelFilterMap = Record<string, unknown>;

export type FiltersByPath = Record<string, TopLevelFilterMap>;

export function syncFiltersByPathEntry({
	filtersByPath,
	pathname,
	filters,
}: {
	filtersByPath: FiltersByPath;
	pathname: string | null;
	filters: TopLevelFilterMap;
}): FiltersByPath {
	if (!pathname) {
		return filtersByPath;
	}

	return {
		...filtersByPath,
		[pathname]: filters,
	};
}

export function readExplicitUrlFilters(): TopLevelFilterMap | null {
	const urlFilters = readTopLevelFiltersFromUrl();
	if (Object.keys(urlFilters).length === 0) {
		return null;
	}

	return { ...urlFilters };
}

/**
 * Resolves active filters when the pathname changes.
 * Cached path filters win for sidebar navigation (no query string).
 * An explicit `?filters=` deep link wins over that cache.
 */
export function resolveFiltersForPath({
	pathname,
	previousPath,
	previousFilters,
	filtersByPath,
}: {
	pathname: string;
	previousPath: string | null;
	previousFilters: TopLevelFilterMap;
	filtersByPath: FiltersByPath;
}): {
	filters: TopLevelFilterMap;
	filtersByPath: FiltersByPath;
} {
	const nextFiltersByPath = syncFiltersByPathEntry({
		filters: previousFilters,
		filtersByPath,
		pathname: previousPath,
	});
	const explicitUrlFilters = readExplicitUrlFilters();

	if (explicitUrlFilters && Object.hasOwn(nextFiltersByPath, pathname)) {
		return {
			filters: explicitUrlFilters,
			filtersByPath: syncFiltersByPathEntry({
				filters: explicitUrlFilters,
				filtersByPath: nextFiltersByPath,
				pathname,
			}),
		};
	}

	if (Object.hasOwn(nextFiltersByPath, pathname)) {
		return {
			filters: { ...nextFiltersByPath[pathname] },
			filtersByPath: nextFiltersByPath,
		};
	}

	if (previousPath === null) {
		const urlFilters = readTopLevelFiltersFromUrl();
		const initialFilters =
			Object.keys(previousFilters).length > 0 ? previousFilters : urlFilters;

		return {
			filters: { ...initialFilters },
			filtersByPath: syncFiltersByPathEntry({
				filters: initialFilters,
				filtersByPath: nextFiltersByPath,
				pathname,
			}),
		};
	}

	const urlFilters = readTopLevelFiltersFromUrl();
	const nextFilters: TopLevelFilterMap =
		Object.keys(urlFilters).length > 0 ? { ...urlFilters } : {};

	return {
		filters: nextFilters,
		filtersByPath: syncFiltersByPathEntry({
			filters: nextFilters,
			filtersByPath: nextFiltersByPath,
			pathname,
		}),
	};
}
